import styled, { css } from 'styled-components';
import { FormElement } from '../../../../components/Form';
import { StyledCheckbox } from '../../../../components/Form/Checkbox/styles';
import FormElementDivider from '../../../components/FormElementDivider';

export const coloredThreewayCheckboxStyle = css`
    .CheckboxMarkChecked.CheckboxMarkChecked--true {
        background-color: ${p => p.theme.c.correct};
        border-color: ${p => p.theme.c.correct};
    }
    .CheckboxMarkChecked.CheckboxMarkChecked--false {
        background-color: ${p => p.theme.c.incorrect};
        border-color: ${p => p.theme.c.incorrect};
    }
`;

export const Container = styled.div`
    margin-top: 16px;
    ${FormElement} {
        ${FormElement} {
            margin-bottom: 0;
            
        }
    }
    ${FormElement} {
        ${StyledCheckbox} {
            margin-bottom: 8px;
        }
    }
    ${coloredThreewayCheckboxStyle}
    
`;

export const Columns = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 32px;
    ${p =>
        p.theme.xs(css`
            grid-template-columns: 1fr;
        `)}
        `;

export const Column = styled.div`
    min-width: 0;
    > ${FormElementDivider} {
        ${p => p.theme.sm.max(css`
            grid-template-columns: 1fr;
        `)}
    }

    textarea {
        min-height: 86px;
    }
`;


export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    button {
        font-size: 16px;
    }
`;